export const SET_ERROR = "SET_ERROR";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
